var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _c("div", {
      staticStyle: { display: "none" },
      attrs: { id: "hiddenIframeBox" }
    }),
    _c(
      "form",
      {
        ref: "pkpIntercityForm",
        attrs: {
          id: "pkp-intercity-form",
          action: "https://bilet.intercity.pl/logowanie.jsp",
          method: "post"
        }
      },
      [
        _c("input", {
          attrs: { type: "hidden", name: "actlogin", value: "Zaloguj+si%EA" }
        }),
        _c("input", {
          attrs: { type: "hidden", name: "password" },
          domProps: { value: _vm.password }
        }),
        _c("input", {
          attrs: { type: "hidden", name: "login" },
          domProps: { value: _vm.login }
        }),
        _c("input", { attrs: { type: "hidden", name: "ref", value: "30" } })
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", [
      _vm._v("Trwa logowanie, proszę czekać "),
      _c("br"),
      _vm._v("(Login in progress, please wait)")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }